export enum MySettingsTab {
  AUTOPOPULATE = 'autoPopulate',
  STARTENDTIME = 'startEndTime',
  SMARTSUGGESTION = 'smartSuggestion'
}
